var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalenderBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75461",
    "data-name": "Group 75461",
    transform: "translate(-141 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40829",
    "data-name": "Group 40829"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(141 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143226",
    "data-name": "Rectangle 143226",
    width: 18,
    height: 18,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons_Q2",
    "data-name": "icons Q2",
    transform: "translate(0.75 0.742)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_60113",
    "data-name": "Path 60113",
    d: "M17.625,4.112H14.25V2.65a.787.787,0,0,0-.637-.788.75.75,0,0,0-.862.75v1.5H7.5V2.65a.787.787,0,0,0-.638-.788A.75.75,0,0,0,6,2.612v1.5H2.625a.75.75,0,0,0-.75.75v12a.75.75,0,0,0,.75.75h15a.75.75,0,0,0,.75-.75v-12A.75.75,0,0,0,17.625,4.112Zm-.75,12H3.375v-7.5h13.5Zm0-9H3.375v-1.5h13.5Z",
    transform: "translate(-1.875 -1.854)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143227",
    "data-name": "Rectangle 143227",
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "translate(2.25 8.258)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143228",
    "data-name": "Rectangle 143228",
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "translate(11.25 8.258)",
    fill: "#185edf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_143229",
    "data-name": "Rectangle 143229",
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "translate(6.75 8.258)",
    fill: "#185edf"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderBlue);
export default __webpack_public_path__ + "static/media/Calender_blue.f058fc4b315d5cfb9928bbe5804814bb.svg";
export { ForwardRef as ReactComponent };